import { FC, useEffect, useRef } from 'react'
import { useT } from '../../../../../../../_metronic/i18n/Metronici18n'
import { ResultadoSolicitacaoExameImagem } from '../../../../atendimento/core/_models'
import { formatarNumeroPedido } from './numeroPedido'
import styles from './ExamesImagem.module.css'

const PASSOS = [
  'exames_imagem.orientacao.passo1',
  'exames_imagem.orientacao.passo2',
  'exames_imagem.orientacao.passo3',
  'exames_imagem.orientacao.passo4',
]

export const OrientacaoCaptura: FC<ResultadoSolicitacaoExameImagem> = ({ solicitacao, criada }) => {
  const { t } = useT()
  const numero = formatarNumeroPedido(solicitacao.accessionNumber, solicitacao.sequencia)
  // o formulário fecha ao enviar: o foco vem para o resultado em vez de cair no body
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    ref.current?.focus()
  }, [solicitacao.id, criada])

  return (
    <div ref={ref} tabIndex={-1} className={`${styles.orientacao} mb-5`} role='status'>
      <p className='fw-bold fs-6 mb-3'>
        {t(criada ? 'exames_imagem.resultado.criado' : 'exames_imagem.resultado.existente')}
      </p>
      <dl className='d-flex flex-wrap align-items-baseline gap-6 mb-3'>
        <div>
          <dt className='fs-7 fw-bold text-gray-700'>{t('exames_imagem.resultado.numero')}</dt>
          <dd className={`${styles.numero} fs-3 fw-bold mb-0`}>{numero.exibicao}</dd>
        </div>
        <div>
          <dt className='fs-7 fw-bold text-gray-700'>{t('exames_imagem.resultado.no_eyer')}</dt>
          <dd className={`${styles.numero} fs-5 fw-bold mb-0`}>{numero.eyer}</dd>
        </div>
      </dl>
      <p className='fw-bold mb-1'>{t('exames_imagem.orientacao.titulo')}</p>
      <ol className='mb-0 ps-5'>
        {PASSOS.map((passo) => (
          <li key={passo}>{t(passo)}</li>
        ))}
      </ol>
    </div>
  )
}
